import { Status } from "@/models/courses.model";

export const coursesMock = [
  {
    name: "Title 1",
    thumbnail: "https://picsum.photos/id/230/200/300",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.PUBLISHED,
  },
  {
    name: "Title 2",
    thumbnail: "https://picsum.photos/id/232/200/300",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.WAITING,
  },
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/id/233/200/300",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.NOT_PUBLISHED,
  },
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/id/234/200/300",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.APPROVED,
  },
];

export const publishedMock = [
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.PUBLISHED,
  },
];

export const waitingMock = [
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.WAITING,
  },
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.WAITING,
  },
];

export const notPublishedMock = [
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.NOT_PUBLISHED,
  },
  {
    name: "Title 2",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.NOT_PUBLISHED,
  },
];

export const approvedMock = [
  {
    name: "Title 3",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.APPROVED,
  },
  {
    name: "Title 2",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.APPROVED,
  },
];

export const reprovedMock = [
  {
    name: "Title 1",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.REPROVED,
  },
  {
    name: "Title 12",
    thumbnail: "https://picsum.photos/200/500",
    description:
      "Et molestiae hic earum repellat aliquid est doloribus delectus. Enim illum odio porro ut omnis dolor debitis natus.",
    status: Status.REPROVED,
  },
];

export const dataLength = {
  all: coursesMock.length,
  published: publishedMock.length,
  waiting: waitingMock.length,
  notPublished: notPublishedMock.length,
  approved: approvedMock.length,
  reproved: reprovedMock.length,
};
